import { useRef, useState } from 'react'

const UNSAVED = 'unsaved'

type Draft = { value: string; revision: number }

export function useAiChatDraft(sessionId?: string) {
  const key = sessionId ?? UNSAVED
  const drafts = useRef<Partial<Record<string, Draft>>>({})
  const [, render] = useState(0)

  const setDraftForKey = (draftKey: string, value: string) => {
    drafts.current[draftKey] = {
      value,
      revision: (drafts.current[draftKey]?.revision ?? 0) + 1,
    }
    render((revision) => revision + 1)
  }
  const setDraft = (value: string) => setDraftForKey(key, value)
  const moveToSession = (nextSessionId: string) => {
    const unsaved = drafts.current[UNSAVED]
    if (unsaved) {
      drafts.current[nextSessionId] = unsaved
      delete drafts.current[UNSAVED]
      render((revision) => revision + 1)
    }
  }
  const captureAcknowledgment = () => {
    const revision = drafts.current[key]?.revision ?? 0

    return (acceptedSessionId?: string) => {
      const acceptedKey = acceptedSessionId ?? key
      if ((drafts.current[acceptedKey]?.revision ?? 0) === revision)
        setDraftForKey(acceptedKey, '')
    }
  }

  return {
    draft: drafts.current[key]?.value ?? '',
    setDraft,
    captureAcknowledgment,
    moveToSession,
  }
}
